export default __webpack_public_path__ + "static/media/3092.235af09d.png";